import { RecorderHealthDetailRow } from "api/interfaces/reportInterface.interface";
import styled from "styled-components";
import * as s from "../../installation/InstallStyled";
import WebAppLink from "components/blocks/link/WebAppLink";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { RecorderDetail } from "../HealthDetail";
import AccountId from "components/atoms/text/labels/AccountId";
import { useMemo } from "react";
import DetailHeader from "components/blocks/subheader/DetailHeader";
import useAccountAccess from "hook/useAccountAccess";

type Props = {
  items: Array<RecorderHealthDetailRow>;
  recorderInfo: RecorderDetail;
};

export default function HealthHeader(props: Props): JSX.Element {
  //BUG [RND-199] web/app link at health report

  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { AccountAccessButton, AccountAccessModal } = useAccountAccess({
    buttonType: (
      <s.AccountName>
        <AccountId
          level={LEVEL_TYPE.EU}
          accountId={props.recorderInfo.accountNumber || ""}
        />
        {props.recorderInfo.accountName}
      </s.AccountName>
    ),
    useTemporary: false,
    isShowOnlyUser: true,
    toPath: "/recorders/list",
  });
  const orgInfo = useMemo(
    () => [
      {
        label: "Organization",
        value: props.recorderInfo.accountId && (
          <AccountAccessButton accountId={props.recorderInfo.accountId} />
        ),
      },
    ],
    [props.recorderInfo]
  );
  const infos = useMemo(
    () =>
      [
        ...(selectedAccount.accountLevel === LEVEL_TYPE.CP ? orgInfo : []),
        ...props.items,
      ].map((item) => {
        if (
          item.label === "Recorder" &&
          selectedAccount.accountLevel === LEVEL_TYPE.EU &&
          !selectedAccount.isHidden
        ) {
          return {
            ...item,
            value: (
              <>
                {item.value}
                <WebAppLink
                  {...props.recorderInfo}
                  accountId={selectedAccount.accountId}
                />
              </>
            ),
          };
        }
        return item;
      }),
    [orgInfo, props.items, selectedAccount.accountLevel]
  );
  return (
    <Container>
      <DetailHeader
        infos={infos as { label: string; value: React.ReactNode }[]}
      />
      {AccountAccessModal}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  grid-area: header;
`;
